import firebase, {database} from '../firebase'
import * as actionTypes from '../actionTypes'
import * as constants from '../Constatnts'
import axios from 'axios'


export function addStoreLocation(storeLocation) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
   
      const response = await axios.post(
        `${constants.API_URL}/user/stores/storelocations`,
        storeLocation,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.newLocation.key;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}





export function getStoreLocations(storeID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/user/stores/${storeID}/storelocations`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  let storeLocations = (response.data.locationData || []).map((item = {}) => {
  const { id, ...rest } = item;

  return {
    key: id || null,
    ...rest,
  };
});

return storeLocations;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function deleteStoreLocations(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
   
      const response = await axios.delete(
        `${constants.API_URL}/user/stores/storelocations/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return true;
      }
      else{
        return false;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function updateStoreLocation(storeLocaiton, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
   
      const response = await axios.put(
        `${constants.API_URL}/user/stores/storelocations/${key}`,
        storeLocaiton,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return true;
      }
      else{
        return false;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
